// TODO: check if component property is necessary.

import React, { forwardRef, HTMLAttributes } from 'react'
import PropTypes from 'prop-types'

export interface CMultiSelectSearchInputProps extends HTMLAttributes<HTMLInputElement> {
  placeholder?: string
}

export const CMultiSelectSearchInput = forwardRef<HTMLInputElement, CMultiSelectSearchInputProps>(
  ({ placeholder, ...rest }, ref) => {
    return (
      <input
        type="text"
        className="form-multi-select-search"
        placeholder={placeholder}
        {...rest}
        ref={ref}
      ></input>
    )
  },
)

CMultiSelectSearchInput.propTypes = {
  placeholder: PropTypes.string,
}

CMultiSelectSearchInput.displayName = 'CMultiSelectSearchInput'
